function populateDirectory (dir, directories, files) {
  dir.directoriesArray = []
  dir.filesArray = []
  for (let id of dir.files) {
    if (files[id]) {
      dir.filesArray.push(files[id].instance)
    }
  }
  for (let id of dir.directories) {
    if (directories[id]) {
      dir.directoriesArray.push(
        populateDirectory(directories[id].instance, directories, files)
      )
    }
  }
  return dir
}

export function directoryTreeSelector (state) {

  let directories = state.restApi.directory.data
  let files = state.restApi.files.data
  let directoryTree = []

  for (let dirId in directories) {
    let dir = directories[dirId].instance
    if (!dir.has_parent) {
      populateDirectory(dir, directories, files)
      directoryTree.push(dir)
    }
  }

  return directoryTree
}

export const genericOptions = (table, k) => (state) => {
  /**
   *  generate options dict from objects
   * @type {Array}
   */
  let ret = []

  for (let loc of Object.values(state.restApi[table].data)) {
    // TODO add typeof k  function
    ret.push({ name: loc.instance[k], value: loc.instance.id })
  }
  return ret
}
